export default __webpack_public_path__ + "static/media/queeraten.86fd2812.png";